import React from 'react';

import i18n from '@nextroll/ar-i18n';

import { CrmOptionType } from 'types/rofl';


const ACCOUNT_ACTION_CRM_HEADER_INFO = {
    salesforce: {
        icon: <i className='fab fa-lg fa-salesforce mr-1' aria-hidden />,
        title: i18n.gettext('Salesforce: Create Contact/Lead Record'),
        message: i18n.gettext('Choose how to create acquired contacts in your CRM. Customize field mapping between AdRoll ABM and Salesforce to direct data into your preferred fields.'),
        link: {
            text: i18n.gettext('AdRoll Help Center: Field Mapping Guide'),
            url: 'https://help.rollworks.com/hc/articles/26302198812045',
        },
    },
    hubspot: {
        icon: <i className='fab fa-lg fa-hubspot mr-1' aria-hidden />,
        title: i18n.gettext('HubSpot: Create Contact Record'),
        message: i18n.gettext('Choose how to create acquired contacts in your CRM. Customize field mapping between AdRoll ABM and HubSpot to direct data into your preferred fields.'),
        link: {
            text: i18n.gettext('AdRoll Help Center: Field Mapping Guide'),
            url: 'https://help.rollworks.com/hc/articles/26301878334477',
        },
    },
    email: {
        icon: <i className='fas fa-lg fa-envelope mr-1' aria-hidden />,
        title: i18n.gettext('Email: Export via CSV'),
        message: i18n.gettext('Choose how to export acquired contacts via email. Customize the email content and recipient list to suit your needs.'),
        link: {
            text: i18n.gettext('AdRoll Help Center: Email Export Guide'),
            url: 'https://help.rollworks.com/hc/articles/26302198812045', // TODO: update with correct link
        },
    },
    other: {
        icon: (
            <>
                <i className='fab fa-salesforce' aria-hidden />
                <i className='fab fa-hubspot mr-1' aria-hidden />
            </>
        ),
        title: i18n.gettext('Create Contact/Lead Record'),
        message: i18n.gettext('Choose how to create acquired contacts in your CRM. Customize field mapping between AdRoll ABM and your CRM to direct data into your preferred fields.'),
        link: {
            text: i18n.gettext('AdRoll Help Center: Contact Discovery'),
            url: 'https://help.rollworks.com/hc/articles/26202476299405',
        },
    },
};

export const AccountActionCrmHeaderSection = ({ crm = 'other' }: { crm?: CrmOptionType | 'email' }) => {
    if (!crm) {
        return null;
    }
    return (
        <div className='workflow-node-panel-header-container' style={{ alignItems: 'baseline' }}>
            {ACCOUNT_ACTION_CRM_HEADER_INFO[crm].icon}
            <div className='workflow-node-panel-header-container-help-section'>
                <h4>{ACCOUNT_ACTION_CRM_HEADER_INFO[crm].title}</h4>
                <div className='workflow-node-panel-header-container-help-section-text'>
                    {ACCOUNT_ACTION_CRM_HEADER_INFO[crm].message}
                </div>
                <a href={ACCOUNT_ACTION_CRM_HEADER_INFO[crm].link.url} rel='noopener noreferrer' target='_blank'>
                    {ACCOUNT_ACTION_CRM_HEADER_INFO[crm].link.text}
                    &nbsp;
                    <i className='ar-icon ar-icon-fw fa-external-link-alt' />
                </a>
            </div>
        </div>
    );
};
